import { FEATURED } from "./actionTypes";

export const filterByFeatured = (books, featureStatus) => {
  return {
    type: FEATURED,
    payload: {
      books: books,
      featureStatus: featureStatus,
    },
  };
};
